import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _, { isEmpty } from "lodash";
import Socket from "socket";
import useSound from "use-sound";
import { setIsLoading } from "redux/loader/action";
import CHPTJoining from "./screens/CHPTJoining";
import CHPTPrePlaying from "./screens/CHPTPrePlaying";
import CHPTPlaying from "./screens/CHPTPlaying";
import CHPTReading from "./screens/CHPTReading";
import CHPTOver from "./screens/CHPTOver";
import { set_chpt_new_card ,set_chpt_result_modal} from "redux/game/action";
import CHPTCardModal from "./components/CHPTCardModal";
import CHPTEvaluating from "./screens/CHPTEvaluating";
import CHPTResult from "./screens/CHPTResult";
import { AnimatePresence } from "framer-motion/dist/framer-motion";


const CHPT = () => {
  const dispatch = useDispatch();
  const cardsRef = useRef(null);
  const [isImageLoaded, setImageLoaded] = useState(false);
  const [playerSelectedCard, setPlayerSelectedCard] = useState("");
  const [winnerSelectedCard, setWinnerSelectedCard] = useState("");
  const [cancelSelect, setCancelSelect] = useState(false);

  const {
    gameReducer: {
      currentUser,
      chpt_new_card,chpt_result_modal,
      roomObj: {
        users,
        id,
        game_state: {
          status,
          prompt,
          game_outputs,
          player_hands,
          played_cards,
          active_player
        } = {}
      }
    },  paramsReducer: {
    
      paramsObj: { default_audio_effect } = {}
    }
  } = useSelector((state) => state);
  const [buzzer_sound] = useSound(default_audio_effect);

  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );

  const isActivePlayer = currentPlayer?.player_id === active_player;

  const currentPlayerCard = player_hands?.find(
    (card) => card.player_id === currentPlayer?.player_id
  );
  const currentPlayerPlayedCard = played_cards?.find(
    (card) => card.player_id === currentPlayer?.player_id
  );
  const  isWinnerPlayer=currentPlayerPlayedCard?.winner;
  const winnerPlayer = played_cards?.find((card) => card.winner == true);
  const winnerPlayerInfo = users?.find(
    (user) => user.player_id === winnerPlayer?.player_id
  );

  const playerObj = player_hands?.find(
    (player) => player.player_id === currentPlayer?.player_id
  );

  const handleCardChooseAction = (type) => {
    let data = {};
    switch (type) {
      case "cardChoose":
        handleIsLoading(true);
        data = {
          action: "play-card",
          roomId: id,
          cardId: playerSelectedCard?.id || "",
          playerId: currentPlayer?.player_id || ""
        };
        break;
      case "winnerChoose":
        data = {
          action: "select-card",
          roomId: id,
          cardId: winnerSelectedCard.id
        };
        break;
      case "winner":
        data = {
          action: "update-status",
          roomId: id
        };
        break;
      default:
        break;
    }
    console.log("h89sadsaddsa ", data);
    Socket.sendMessage(data);
  };
  const handleChoose = useCallback(
    _.debounce((type) => handleCardChooseAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [id, currentPlayer, playerSelectedCard, winnerSelectedCard]
  );

  const handleCancelClick = () => {
    setCancelSelect(true);
    setPlayerSelectedCard("");
    setWinnerSelectedCard("");
  };

  const handleIsLoading = (value) => {
    dispatch(setIsLoading(value));
  };
  const handle_play_card = (res) => {
    if (res && res.room && !_.isEmpty(res.cardId)) {
      handleIsLoading(false);
      const player_cards = res.room.game_state.player_hands.find(
        (card) => card.player_id === currentPlayer.player_id
      ).cards;

      const newCard = player_cards.find((newCard) =>
        cardsRef.current.every((prevCard) => prevCard.id !== newCard.id)
      );
      setPlayerSelectedCard("");

      !_.isEmpty(newCard) &&
        dispatch(set_chpt_new_card({ active: true, card: newCard }));
    }
  };

  const handle_play_card_error = (err) => {
    if (err) {
      handleIsLoading(false);
    }
  };

  const handleNewCardModalClose = () => {
    dispatch(set_chpt_new_card({ active: false, card: {} }));
    dispatch(set_chpt_result_modal( false));

  };
  const handleNewCard = () => {
    dispatch(set_chpt_new_card({ active: false, card: {} }));
  };

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageLoaded(true);
    };
    img.src = prompt?.url;

    return () => {
      img.onload = null; 
    };
  }, [prompt?.url, status === "PrePlay" ]);
  useEffect(() => {
    return Socket.addListener(
      "play-card",
      handle_play_card,
      handle_play_card_error
    );
  }, [cardsRef]);

  useEffect(() => {
    return Socket.addListener("select-card", handleCancelClick);
  }, []);
 
  useEffect(() => {
    if (status === "Result") {
      dispatch(set_chpt_result_modal( true));
    }
    if (status === "Joining" ||status === "PrePlay" ||status === "Playing" ||status === "Reading"||status === "Evaluating"  ||status==="Over")  {
      dispatch(set_chpt_result_modal( false));
    }
    if (status === "Playing") {
      cardsRef.current = playerObj.cards;
      dispatch(set_chpt_new_card({ active: false, card: {} }));
    }

    if (
      status === "Joining" ||
      status === "PrePlay" ||
      status === "Result" ||
      status === "Over"
    ) {
      handleNewCard();
    }
    if (status === "Playing") {
      cardsRef.current = currentPlayerCard.cards;
      dispatch(set_chpt_new_card({ active: false, card: {} }));
    }
  }, [status]);

 

  return (
    <div>
      <AnimatePresence exitBeforeEnter>
        <div>
          {status === "Joining" && <CHPTJoining key="CHPT_0" users={users} />}
          {status === "PrePlay" && (
            <CHPTPrePlaying
              key="CHPT_1"
              isActivePlayer={isActivePlayer}
              roomId={id}
              currentPlayerCard={currentPlayerCard}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}
          {status === "Playing" && isImageLoaded  && (
            <CHPTPlaying
              key="CHPT_2"
              isImageLoaded={isImageLoaded}
              isActivePlayer={isActivePlayer}
              roomId={id}
              currentPlayerCard={currentPlayerCard}
              prompt={prompt}
              currentPlayer={currentPlayer}
              setPlayerSelectedCard={setPlayerSelectedCard}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}
          {status === "Reading" && (
            <CHPTReading
              key="CHPT_3"
              isActivePlayer={isActivePlayer}
              roomId={id}
              currentPlayerCard={currentPlayerCard}
              prompt={prompt}
              currentPlayer={currentPlayer}
              played_cards={played_cards}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}

          {status === "Evaluating" && (
            <CHPTEvaluating
              key="CHPT_4"
              isActivePlayer={isActivePlayer}
              roomId={id}
              currentPlayerCard={currentPlayerCard}
              prompt={prompt}
              currentPlayer={currentPlayer}
              played_cards={played_cards}
              setWinnerSelectedCard={setWinnerSelectedCard}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}

          {status === "Result" && (
            <CHPTResult
              key="CHPT_5"
              isWinnerPlayer={isWinnerPlayer}
              winnerPlayerInfo={winnerPlayerInfo}
              isActivePlayer={isActivePlayer}
              currentPlayerCard={currentPlayerCard}
              buzzer_sound={buzzer_sound}
              default_audio_effect={default_audio_effect}
            />
          )}
          {status === "Over" && <CHPTOver  users={users}/>}
        </div>

        {false && <CHPTOver key="CHPT_6" />}
      </AnimatePresence>
      <AnimatePresence exitBeforeEnter>
        {!isEmpty(playerSelectedCard) && isEmpty(currentPlayerPlayedCard) && (
          <CHPTCardModal
            key="CHPT_7"
            card={playerSelectedCard}
            crossButtonClick={handleCancelClick}
            buttonClick={() => handleChoose("cardChoose")}
            cancelSelect={cancelSelect}
          />
        )}

        {!isEmpty(winnerSelectedCard) && (
          <CHPTCardModal
            key="CHPT_8"
            card={winnerSelectedCard}
            crossButtonClick={handleCancelClick}
            buttonClick={() => handleChoose("winnerChoose")}
            cancelSelect={cancelSelect}
          />
        )}

        {!isEmpty(chpt_new_card?.card) && (
          <CHPTCardModal
            key="CHPT_9"
            card={chpt_new_card?.card}
            isNewCard={true}
            crossButtonClick={handleNewCardModalClose}
            buttonClick={handleNewCardModalClose}
            cancelSelect={cancelSelect}
          />
        )}

        {chpt_result_modal && !isActivePlayer && (
          <CHPTCardModal
            key="CHPT_10"
            card={currentPlayerPlayedCard?.card}
            isresultModal={true}
            crossButtonClick={handleNewCardModalClose}
            isWinnerPlayer={isWinnerPlayer}
            winnerButtonClick={() => handleChoose("winner")}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default CHPT;
